import styles from "./payment-methods.module.scss";

export const InternetBanking = ({ commonData, productName }) => (
  <>
    <div className={styles.headText}>
      {productName} is loaded as a bill payee with most major banks.
    </div>
    <p>
      Select {productName} from your bill payment options and follow
      instructions to set up regular payments.
    </p>
    <div role="table" className={styles.table}>
      <div role="row" className={styles.row}>
        <div role="cell" className={styles.label}>
          Account number
        </div>
        <div role="cell">{commonData.accountNumber}</div>
      </div>
    </div>
  </>
);
